import * as React from 'react';
import { Dialog, DialogFooter, DialogType, PrimaryButton, SwatchColorPicker, DefaultButton } from '@fluentui/react';
import { __ElementColor, __MessageTypes } from '../../../../../common/Dictionaries';
import { updateBoardElement } from '../../../../../services/sKPI/board.service';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import PropTypes from 'prop-types';
import MessageBox from '../../../../Common/Message/MessageBox';
import { isNullOrEmpty, showMessage } from '../../../../../common/Helpers';

export const CColorPicker = (props) => {
  const { t } = useTranslation();

  const { 
    inputParam_SetterColor = null,
    inputParam_ElementItem = null,
    inputParam_ToggleHideDialog = null,
    inputParam_HideDialog = null,
    inputParam_SetterStatusFly = null,
    inputParam_UnselectableColors = [],

    inputParam_BoardElements= null,
    inputParam_SetBoardElements= null
  } = props;

  const [color, setColor] = useState(null);
  const [messageConfig, setMessageConfig] = useState({
    message : null,
    messageType : "",
    showMessage : false,
  });

  const onUpdateColor = (event, id, _color) => {
    setColor(_color)
    if (_color !== color) {
      showMessage(setMessageConfig, false, null, null)
    }
  }

  const onSaveColor = () => {

      if (inputParam_UnselectableColors.filter(x => x === color).length === 0) {
        inputParam_ElementItem.htmlColor = color;

        updateBoardElement(inputParam_ElementItem.id, inputParam_ElementItem).then((response) => {
            inputParam_SetterColor && inputParam_SetterColor(color);
            inputParam_ToggleHideDialog && inputParam_ToggleHideDialog();
            inputParam_SetterStatusFly && inputParam_SetterStatusFly(prevState => ({
              fireUpdate: true,
            }))
            showMessage(setMessageConfig, false, null, null)

            inputParam_BoardElements.map((item, index) => {
              if (item.id === inputParam_ElementItem.id) {
                item._isValidElement = item.l_roles.length > 0 && item.l_variables.length > 0 && !isNullOrEmpty(inputParam_ElementItem.htmlColor)
              }
            })
            inputParam_SetBoardElements && inputParam_SetBoardElements(inputParam_BoardElements)

        }).catch((error) => {
            let message = "";
  
            if (!error.response) {
                message = 'data-lang-msg-networkerror'
            } else {
                message = 'data-lang-msg-operationerror'
            }

            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(message))
        })
      }
      else {
        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-coloralredyselected'))
      }
  };

  return (
    <>
      <Dialog
          hidden={inputParam_HideDialog}
          onDismiss={inputParam_ToggleHideDialog}
          minWidth={400}
          maxWidth={400}
          dialogContentProps={{
            type: DialogType.normal,
            title: 'Color picker',
            subText: 'Select the element color.',
          }}
          modalProps={{
            isBlocking: true,
            styles: { main: { minWidth: 600 } },
          }}
        >
          <SwatchColorPicker
            columnCount={7}
            cellHeight={35}
            cellWidth={35}
            cellShape={'circle'}
            onChange={onUpdateColor}
            colorCells={__ElementColor}
            selectedId={__ElementColor.find(x => x.color === color) !== undefined ? __ElementColor.find(x => x.color === color).id : null}
          />
        <DialogFooter>
          <MessageBox
              inputParam_Message={ messageConfig.message }
              inputParam_Display={ messageConfig.showMessage }
              inputParam_MessageType={ messageConfig.messageType }
              inputParam_SetterMessage={ setMessageConfig }
          />
        </DialogFooter>
        <DialogFooter>
          <PrimaryButton onClick={onSaveColor} text={t('data-lang-btn-select')} />
          <DefaultButton onClick={inputParam_ToggleHideDialog} text={t('data-lang-btn-cancel')} />
        </DialogFooter>
      </Dialog>

        
    </>
  );
};

CColorPicker.propTypes = {
  inputParam_SetterColor: PropTypes.func.isRequired,
  inputParam_ElementItem: PropTypes.object.isRequired,
  inputParam_ToggleHideDialog: PropTypes.func.isRequired,
  inputParam_HideDialog: PropTypes.bool.isRequired,
  inputParam_SetterStatusFly: PropTypes.func.isRequired,
  inputParam_UnselectableColors: PropTypes.array.isRequired,

  inputParam_BoardElements: PropTypes.array.isRequired,
  inputParam_SetBoardElements: PropTypes.func.isRequired,
};